<nz-card>
    <nz-row [nzJustify]="'space-between'" [nzAlign]="'bottom'">
        <div>
            <h2>Reports</h2>
        </div>
        <button nz-button nzType="primary" (click)="navigateToDataGate()" *ngIf="auth.checkMenu(['DGL'])" style="margin-bottom: 20px;">
        DataGate (Auto-login)
        </button>
        <div>
            <p style=" color: #888;">Reports will be sent to <span style="font-weight: 500;">{{ auth.user.email }}</span></p>
        </div>
    </nz-row>

<nz-table #reportsTable [nzLoading]="isLoading" [nzData]="reports" [nzFrontPagination]="false">
    <thead>
        <tr>
        <th>Report Name</th>
        <th>Last Requested Date</th>
        <th>Sent</th>
        <th></th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let report of reportsTable.data">
            <td>{{ report.name }}</td>
            <td>{{ report.dtScheduled ? (report.dtScheduled + 'Z' | date:'short') : 'N/A' }}</td>
            <td>
                <i nz-icon *ngIf="report.dtSent" nzType="check-circle" nzTheme="outline" style="color: #52c41a;" [nz-tooltip]="'Sent: ' + (report.dtSent + 'Z' | date:'short')"></i>
                <i nz-icon *ngIf="report.dtScheduled && !report.dtSent" nzType="close-circle" nzTheme="outline" style="color: #ff4d4f;"></i>
            </td>
            <td>
                <button nz-button nzType="primary" nzSize="small" [disabled]="isRequestDisabled(report)" [nz-tooltip]="isRequestDisabled(report) ? 'You can request this report again after 15 minutes.' : 'Request this report'" (click)="requestReport(report.id)">Request Report</button>
            </td>
        </tr>
    </tbody>
</nz-table>
</nz-card>